// extracted by mini-css-extract-plugin
module.exports = {"root":"cards_root__9KKzZ","items":"cards_items__ghkaz","item":"cards_item__8M0sk","icon":"cards_icon__WvyZG","title":"cards_title__ge3vb","description":"cards_description__RncBA"};